module.exports = __webpack_public_path__ + "img/jinko.8068d2ed.png";